import React, { useEffect, useState } from "react";
import styles from "./Footer.module.css";

export default function Footer() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    });
  }, []);

  const scrollToTop = () => {
    if (window.scrollY > 200) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footer_container}>
        <svg
          className={styles.footer_logo}
          onClick={() => scrollToTop()}
          width="90"
          height="42"
          viewBox="-2 -2 90 42"
          id="logo-lab-small"
          y="353"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path
              d="M15.698 11.21H10.94v7.741H8.718V9.228h9.202v9.723h-2.222V11.21zm4.795 7.741V9.228h2.222v6.339l5.38-6.34h1.93v9.724h-2.222v-6.32l-5.38 6.32h-1.93zm12.002-9.723h2.222v3.945l4.387-3.945h2.904l-4.932 4.394 5.108 5.33h-2.846l-3.88-4.003-.74.692v3.31h-2.223V9.228zm16.984 6.656v-.935c-.41-.13-1.13-.261-1.852-.261-1.599 0-2.67.318-2.67 1.29 0 .767.74 1.234 1.87 1.234 1.346 0 2.204-.673 2.652-1.328zm-6.18-5.44c.955-.898 2.593-1.44 4.25-1.44 2.671 0 4.153 1.458 4.153 4v5.947h-2.223v-1.066c-.604.636-1.637 1.178-3.138 1.178-2.223 0-3.685-1.196-3.685-3.066 0-2.17 2.047-3.086 4.737-3.086.721 0 1.618.113 2.086.262.02-1.402-.546-2.188-2.183-2.188-1.111 0-1.93.318-2.905 1.029l-1.092-1.57zm20.09 6.282c-.839 1.57-2.593 2.393-4.348 2.393-3.255 0-5.458-1.982-5.458-5.048 0-2.88 2.144-5.068 5.341-5.068 2.086 0 3.685.917 4.348 2.207l-1.658 1.047c-.682-.879-1.442-1.272-2.592-1.272-1.833 0-3.14 1.253-3.14 3.086 0 1.757 1.327 3.066 3.374 3.066 1.15 0 1.988-.56 2.553-1.383l1.58.972zm10.318 0c-.839 1.57-2.593 2.393-4.348 2.393-3.255 0-5.458-1.982-5.458-5.048 0-2.88 2.144-5.068 5.341-5.068 2.086 0 3.685.917 4.348 2.207l-1.657 1.047c-.683-.879-1.443-1.272-2.593-1.272-1.833 0-3.139 1.253-3.139 3.086 0 1.757 1.326 3.066 3.373 3.066 1.15 0 1.988-.56 2.554-1.383l1.579.972zm5.953.411c1.852 0 3.139-1.196 3.139-3.066 0-1.889-1.385-3.086-3.14-3.086-1.773 0-3.118 1.178-3.118 3.086 0 1.757 1.267 3.066 3.119 3.066zm0-8.134c3.197 0 5.439 2.132 5.439 5.068 0 2.917-2.242 5.048-5.44 5.048-3.157 0-5.419-2.131-5.419-5.048 0-2.936 2.203-5.068 5.42-5.068zM.82 37.333h2.252V.604H.82v36.73z"
              fill="#1A1919"
            />
            <path
              d="M8.718 37.332h2.212V24.348H8.718v12.984zm13.766-3.124v-.95c-.64-.213-2.107-.368-2.826-.368-1.983 0-2.71.637-2.71 1.364 0 .71.498 1.344 2.139 1.344 1.163 0 2.865-.469 3.397-1.39zm-7.268-5.438c1.121-.806 2.913-1.358 4.565-1.358 2.664 0 4.88 1.303 4.88 4.224v5.696h-2.177v-1.34c-.82.91-2.349 1.452-3.727 1.452-2.328 0-4.102-1.327-4.102-2.945 0-2.163 1.953-3.19 4.412-3.19 1.459 0 2.718.284 3.417.502 0-1.843-1.756-2.421-3.063-2.421-1.251 0-2.057.291-3.095.899l-1.11-1.519zm15.086 1.874v4.126c.592.468 1.582.83 2.772.828 1.575-.002 3.242-.899 3.242-3.248 0-1.784-1.332-2.948-3.077-2.948-1.606 0-2.279.61-2.937 1.242zm-2.14-6.296h2.213v4.164c.859-.59 1.62-1.1 3.317-1.1 2.869 0 4.908 1.877 4.908 4.749 0 3.208-2.383 5.339-5.356 5.339-1.788 0-3.474-.475-5.081-1.685V24.348z"
              fill="#DE4A6A"
            />
          </g>
        </svg>

        <p className={styles.footer_dev}>
          dev by {}
          <a
            href="https://github.com/hiiam-andy"
            className={styles.footer_myLink}
          >
            hiiam-andy
          </a>
        </p>
        <a
          href="https://picasso-diagnostic.ru/patients/"
          className={styles.footer_myLink}
        >
          Пикассо
        </a>
        {visible && (
          <button
            className={styles.top_btn}
            onClick={() => {
              scrollToTop();
              setVisible(false);
            }}
          >
            <svg
              width="22"
              height="14"
              viewBox="-2 -2 22 14"
              id="arrow-up-purple"
              x="507.24"
              y="299"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.522 9.984L18 8.605 9.001 0l-9 8.59L1.446 10 9 2.632z"
                fill="#ffffff"
              />
            </svg>
          </button>
        )}
      </div>
    </footer>
  );
}
